import { PropsWithChildren } from 'react';

import { CardRoot, CardRootProps, GridItem, LinkBox } from '@oaknorth/component-core-v2';

const NARROW_CARD_COLSPAN = 2;
const WIDE_CARD_COLSPAN = 3;
const FULL_CARD_COLSPAN = 6;

export enum HomePageCardType {
  NARROW = 'NARROW',
  WIDE = 'WIDE',
  FULL = 'FULL',
}

interface HomePageCardProps extends CardRootProps {
  type: HomePageCardType;
  isLocked?: boolean;
  to?: string;
}

function getColspanFromType(type: HomePageCardType): number {
  switch (type) {
    case HomePageCardType.NARROW:
      return NARROW_CARD_COLSPAN;
    case HomePageCardType.WIDE:
      return WIDE_CARD_COLSPAN;
    case HomePageCardType.FULL:
      return FULL_CARD_COLSPAN;
  }
}

export function HomePageCard({ type, isLocked = false, children, ...props }: PropsWithChildren<HomePageCardProps>) {
  return (
    <GridItem colSpan={getColspanFromType(type)} display="flex" data-testid="home-page-card">
      <CardRoot
        display="flex"
        flex="1 1 auto"
        borderRadius="md"
        {...(isLocked
          ? { background: 'gray.50', border: '2px dashed', borderColor: 'gray.300', boxShadow: 'none' }
          : { background: 'white', border: '2px solid', borderColor: 'gray.200', boxShadow: 'xl' })}
        {...props}
      >
        <LinkBox>{children}</LinkBox>
      </CardRoot>
    </GridItem>
  );
}
